var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLootboxIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 1.63636L19.5 0H1.5L0 1.63636V7.15909L1.36312 9L0 10.8409V16.3636L1.5 18H19.5L21 16.3636V10.8409L19.6369 9L21 7.15909V1.63636ZM1.5 2.31392L2.12109 1.63636H18.8784L19.4995 2.31392V6.58074L18.3141 8.18182H14.437L12.937 5.72727H8.06203L6.56203 8.18182H2.68547L1.5 6.58074V2.31392ZM13.1348 9L12.135 10.6364H8.86547L7.86563 9L8.86547 7.36364H12.135L13.1348 9ZM2.12109 16.3636L1.5 15.6861V11.4193L2.68547 9.81818H3.9375V16.3636H2.12109ZM5.43703 16.3636V9.81818H6.56203L8.06203 12.2727H12.937L14.437 9.81818H15.562V16.3636H5.43703ZM19.4995 15.6861L18.8784 16.3636H17.062V9.81818H18.3141L19.4995 11.4193V15.6861Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLootboxIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lootbox-icon.12b3e5b9a13547e4990ac9e3a4e2f215.svg";